import { MapsCandeactiveGuardService } from './services/maps-candeactive-guard.service';
import { ItemdetailsCandeactiveGuardService } from './services/itemdetails-candeactive-guard.service';
import { ReportsComponent } from './reports/reports.component';
import { UsersComponent } from './users/users.component';
import { LoginpageComponent } from './loginpage/loginpage.component';
import { ItemdetailsComponent } from './itemdetails/itemdetails.component';
import { MapsComponent } from './maps/maps.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ItemslistComponent } from './itemslist/itemslist.component'; // Add this
import { WarehousesComponent } from './warehouses/warehouses.component'; // Add this
import { HistoryComponent } from './history/history.component';
import { MatDialogModule } from '@angular/material/dialog';
import { TagComponent } from './tag/tag.component';

const routes: Routes = [
  { path: 'itemsList', component: ItemslistComponent },
  { path: 'warehouses', component: WarehousesComponent },             // Add this
  { path: 'maps', component: MapsComponent, canDeactivate: [MapsCandeactiveGuardService] },
  { path: 'itemdetails', component: ItemdetailsComponent, canDeactivate: [ItemdetailsCandeactiveGuardService] },
  { path: 'history', component: HistoryComponent },
  { path: 'login', component: LoginpageComponent },
  { path: 'users', component: UsersComponent },
  { path: 'reports', component: ReportsComponent },
  { path: 'tag', component: TagComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes), MatDialogModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
